/**
 * Public how-to / help guide links (Galldris Cloud / Nextcloud shares).
 * Add new guides here and import where needed.
 */
export const HELP_LINKS = {
  resetPasswordLogin: 'https://nc.galldris.co.uk/s/rm4F33imowHgxET',
  requisitionReturn: 'https://nc.galldris.co.uk/s/PC45nk8JNkaRk5M',
  signUpInduction: 'https://nc.galldris.co.uk/s/GS8R3cJFYDs9njq',
  goodCalls: 'https://nc.galldris.co.uk/s/miwJR9S8pktJwTG',
  closeCalls: 'https://nc.galldris.co.uk/s/2QfZpwwiF6PkSmr'
};
